import {
  AnomalyApi,
} from '@api/twin/AnomalyApi';
import { TwinType } from '@api/twin/TwinApi';
import { NotificationCenter, useTeiaViewerContext } from '@stereograph/teiaviewer';
import {
  useMutation,
  useQueryClient,
} from '@tanstack/react-query';
import { usePluginTranslation } from '@translation';
import { anomalyQueryKeys } from '../query-keys';
import { useDisplayAnomalyCsvImportNotification } from './useDisplayAnomalyCsvImportNotification';

export const useImportCsvAnomaly = (projectId: number) => {
  const { viewer } = useTeiaViewerContext();
  const client = viewer.twinApiClient;
  const queryClient = useQueryClient();
  const { displayAnomalyCsvImportNotification: buildAnomalyErrorMessage } = useDisplayAnomalyCsvImportNotification();
  const { t } = usePluginTranslation();

  const { mutateAsync: importCsvAnomaly } = useMutation({
    mutationFn: async ({
      files,
      twinProjectType,
    }: {
      files: Array<File>;
      twinProjectType: TwinType;
    }) => await AnomalyApi(client).importCsvAnomaly(projectId, files, twinProjectType),
    onSuccess: async (response) => {
      await queryClient.invalidateQueries({
        queryKey: anomalyQueryKeys.default,
      });
      buildAnomalyErrorMessage(response);
    },
    onError: () => {
      NotificationCenter.instance.pushNotification({
        type: t('anomaly_plugin.notification_type_text'),
        status: 'error',
        message: t('anomaly_plugin.info_widget.upload.excel_import_error_text'),
        title: t('anomaly_plugin.info_widget.upload.notification_title'),
        displayed: true,
      });
    },
  });

  return {
    importCsvAnomaly,
  };
};
